module.exports = __webpack_public_path__ + "img/buy-me-a-coffee-logo.fe8d8e5d.svg";